import withCancellationWorkflow from './withCancellationWorkflow'
import View from './view'

export default withCancellationWorkflow(View)
